import styled from 'styled-components';
import { float } from '../styles/GlobalStyle';

const Layer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
`;

const Blob = styled.div<{
  $size: string;
  $top: string;
  $left: string;
  $color: string;
  $delay: string;
  $duration: string;
}>`
  position: absolute;
  top: ${({ $top }) => $top};
  left: ${({ $left }) => $left};
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  background: ${({ $color }) => $color};
  border-radius: 50%;
  filter: blur(46px);
  opacity: 0.55;
  animation: ${float} ${({ $duration }) => $duration} ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay};
`;

/** Fluff floating behind everything. Purely decorative. */
const BLOBS = [
  { size: '380px', top: '-8%', left: '-10%', color: '#ffc9e3', delay: '0s', duration: '13s' },
  { size: '300px', top: '18%', left: '78%', color: '#c9e7ff', delay: '1.6s', duration: '16s' },
  { size: '260px', top: '62%', left: '-6%', color: '#d9ccff', delay: '3.1s', duration: '15s' },
  { size: '340px', top: '74%', left: '66%', color: '#ffe6c4', delay: '0.8s', duration: '18s' },
  { size: '200px', top: '40%', left: '38%', color: '#c8f5e2', delay: '2.4s', duration: '14s' },
] as const;

export function Backdrop() {
  return (
    <Layer aria-hidden="true">
      {BLOBS.map((blob, index) => (
        <Blob
          key={index}
          $size={blob.size}
          $top={blob.top}
          $left={blob.left}
          $color={blob.color}
          $delay={blob.delay}
          $duration={blob.duration}
        />
      ))}
    </Layer>
  );
}
